<!-- 加油记录操作 -->
<template>
  <div>
    <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false" append-to-body custom-class="drawer_box" :direction="dataActionBox.openMode" size="50%">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index==0">
                <el-form id="mainInfo" :inline="true" label-width="100px" size="mini" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" class="baseForm">
                  <el-row>
                    <el-form-item :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1? [{required:  formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">
                      <!-- 加油卡 -->
                      <el-tooltip v-if="formOneValue.entityField == 'cardId'" class="item" :disabled="sendDataInfo.cardCode==null||sendDataInfo.cardCode==''?true:false || sendDataInfo.cardCode.length<=9" effect="dark"
        :content="sendDataInfo.cardCode" placement="bottom-start">
                      <el-input  v-model="sendDataInfo.cardCode" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId,'cardId')">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                      </el-tooltip>
                      <!-- 加油时间 -->
                      <el-date-picker :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'fuelDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                      <!-- 油卡类型 -->
                      <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'cardType'" v-model="sendDataInfo.cardName"></el-input>
                      <!-- 价格和升 -->
                      <el-input :disabled="formOneValue.isChange==0" type="number" v-else-if="formOneValue.entityField == 'price'" v-model="sendDataInfo[formOneValue.entityField]" min="0" @input="calculateOilMoney" :maxlength="$store.state.inputLength" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                      <el-input :disabled="formOneValue.isChange==0" type="number" v-else-if="formOneValue.entityField == 'refuelingVolume'" v-model="sendDataInfo[formOneValue.entityField]" min="0" @input="calculateOilMoney" :maxlength="$store.state.inputLength" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                      <!-- 车型号 -->
                      <el-tooltip v-else-if="formOneValue.entityField == 'carNum'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                      <el-input  v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId,'carNum')">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                      </el-tooltip>
                      <!-- 司机 -->
                      <el-tooltip v-else-if="formOneValue.entityField == 'driverName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                      <el-input  v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId,'driverName')">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                      </el-tooltip>
                      <el-input :disabled="formOneValue.isChange==1?false:true" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div class="foots">
          <el-button type="primary" @click="initActionBox">关闭</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 检索方案弹窗 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
    </el-dialog>
  </div>
</template>

<script>
import NP from "number-precision"
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
  name: "oilCardRefuelingAction",
  props: [],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        "carModel": "", //车型
        "carNum": "",   //车牌
        "cardId": 0,
        cardCode: '',   //ka
        "cardType": 0,  //卡类型
        "cardName": '',
        "createTime": 0,
        "creater": 0,
        "driverId": "",
        "driverName": "",
        "fuelDate": 0,
        "gasStationAddr": "",
        "gasStationName": "",
        "money": 0,
        "price": "",
        "recordReserves1": "",
        "recordReserves2": "",
        "recordReserves3": "",
        "recordReserves4": "",
        "recordReserves5": "",
        "recordReserves6": "",
        "refuelingVolume": "",
        "updateTime": 0,
      },
      oilCardTypeList: [], //油卡类型
      DialogVisible: false,   //检索
      seWidth: '0',
      seId: 0,
      seTitle: "",
      searchType: '',
      parentSearchData: {}
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      this.seId = sId
      this.searchType = type
      this.DialogVisible = true
      this.parentSearchData[type] = this.sendDataInfo[type]
      if (type == 'driverName') {   //司机
        this.parentSearchData.opmName = this.sendDataInfo.driverName
      } else if (type == 'carNum') {//车
        this.parentSearchData.vmLicensecode = this.sendDataInfo.carNum
      } else if (type == 'cardId') {//卡
        this.parentSearchData.cardName = this.sendDataInfo.cardName
      }
    },
    //检索带回数据
    changeInputModel(val) {
      // console.log('返hui',val)
      if (val != "" || val != undefined) {
        this.DialogVisible = false		//关闭商品检索窗口
        if (this.searchType == 'driverName') {   //司机
          this.sendDataInfo.driverId = val.opmId
          this.sendDataInfo.driverName = val.opmName
        } else if (this.searchType == 'carNum') {//车
          this.sendDataInfo.carModel = val.vmVinno
          this.sendDataInfo.carNum = val.vmLicensecode
        } else if (this.searchType == 'cardId') {//卡
          this.sendDataInfo.cardId = val.cardId
          this.sendDataInfo.cardCode = val.cardCode
          this.sendDataInfo.cardType = val.cardType
          this.sendDataInfo.cardName = this.getOilTypeStr(val.cardType)
        }
      } else {
        this.DialogVisible = false
        this.$message({
          message: '检索失败',
          type: 'error'
        })
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    //计算油价总额
    calculateOilMoney() {
      if (this.sendDataInfo.price && this.sendDataInfo.refuelingVolume) {
        // 计算金额 单价*数量
        this.sendDataInfo.money = this.$common.getDecimalInfo(3, NP.times(this.sendDataInfo.price, this.sendDataInfo.refuelingVolume))
      } else {
        this.sendDataInfo.money = 0
      }
    },
    //保存
    async sendDataAction() {
      let flag = false
      this.$refs['sendDataInfo'].validate((valid) => {
        if (valid) { } else {
          this.$message({
            message: '请完善加油记录的必填信息',
            type: 'error'
          })
          flag = true
          return false;
        }
      })
      if (flag) return false;
      if (this.sendDataInfo.money <= 0) {
        this.$message({
          message: '请填写正确的加油金额',
          type: 'error'
        })
        return false;
      }

      // console.log('zeng', this.sendDataInfo);
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
      let responseData

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.cardrecordAdd(sendData)
      } else {
        responseData = await this.$http.gascardUpdate(sendData)
      }
      if (responseData && responseData.status == 200) {
        this.$message({
          message: this.dataActionBox.boxTitle + '成功',
          type: 'success'
        })
        this.$parent.getDataList()
        this.init()
        this.$refs['sendDataInfo'].resetFields()
        this.dataActionBox.showStatus = false

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        })
      }
    },

    //取消新增
    initActionBox() {
      if (this.dataActionBox.actionType == 5) return this.dataActionBox.showStatus = false
      this.dataActionBox.showStatus = false
      this.init();
      this.$refs['sendDataInfo'].resetFields();
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        if (key == 'fuelDate' || key == 'createTime' || key == 'updateTime') {
          this.sendDataInfo[key] = this.$moment().valueOf()
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.money = 0
      this.dataActionBox.actionType = 0
      this.dataActionBox.boxTitle = ''
    },

    //父级传入 获取列表
    openBox(cate, formData, oldData = "") {
      // console.log('oldData', oldData);
      this.formDataList = formData;
      this.init();
      this.dataActionBox.showStatus = true
      this.dataActionBox.actionType = cate;
      this.showTabs = formData[0].jciName;
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增加油记录";
        this.dataActionBox.openMode = "ltr";
      } else {
        this.dataActionBox.boxTitle = "修改加油记录";
        this.dataActionBox.openMode = "rtl";
        this.sendDataInfo = JSON.parse(JSON.stringify(oldData))
        this.sendDataInfo.cardType = Number(this.sendDataInfo.cardType)
      }
    },
    //获取油卡类型字符
    getOilTypeStr(str) {
      let num = parseFloat(str)
      let getStr = ''
      this.oilCardTypeList.forEach((v) => {
        if (v.diId == num) {
          getStr = v.diName
          return false
        }
      })
      return getStr
    },
    //获取油卡类型
    async getOilType() {
      let responseData = await this.$http.getCateDictionariesData({
        ids: [36],
      })
      if (responseData.status == 200) {
        this.oilCardTypeList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        })
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getOilType()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
